/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useToast } from '../../../context/toast-context';
import useAPIHandler from '../../../hook/use-api-handler';
import { getInputFieldProps, pickProperties, safeToString } from '../../../utils/common';
import fetchDataWithPromise from '../../../utils/fetch-data';
import { FAMILY_API, FAMILY_FORM_FIELDS, FAMILY_INITIAL_STATE } from './family-constant';
import { createFamilySchema } from './family-validation';


const useEmployeeFamilyService = () => {
  const [errors, setErrors] = useState({});
  const [createFormUpdateLoading, setCreateFormUpdateLoading] = useState(false);
  const [deleteDialogShow, setDeleteDialogShow] = useState(false);
  const [seletedEmployee, setSeletedEmployee] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);
  const { fetchData } = useAPIHandler();
  const [employeeFamilyInput, setEmployeeFamilyInput] = useState(structuredClone(FAMILY_INITIAL_STATE));
  const { showToastMessage } = useToast();

  const [open, setOpen] = useState(false);
  const { id: employeeID } = useParams()
  const handleClickOpen = (_, data) => {
    setErrors({});
    setEmployeeFamilyInput(data ? data : structuredClone(FAMILY_INITIAL_STATE))
    setOpen(true);
  };
  const handleClose = () => {
    setDeleteDialogShow(false);
    setOpen(false)
  };

  function handleDeleteDialogOpen(data) {
    setDeleteDialogShow(true);
    setSeletedEmployee(data);
  }
  async function handleDeleteFamilyFn() {
    setCreateFormUpdateLoading(true);
    try {
      const res = await fetchData({
        seletedEmployee,
        ...FAMILY_API.FAMILY_DELETE,
        data: [],
        url: `${FAMILY_API.FAMILY_DELETE.url}/${employeeID}/delete/${seletedEmployee}`
      });
      showToastMessage({ message: "Family Details Deleted successfully!" });
      setCreateFormUpdateLoading(false);
      setResource(fetchDataWithPromise(`${FAMILY_API.FAMILY_LIST.url}/${employeeID}`));
      handleResetForm()
      handleClose()
    } catch (error) {
      if (error?.type === "JoiValidationError") {
        const errorsAll = {};

        error?.errors?.map((item) => {
          const { field, message } = item;
          errorsAll[field] = message;
        });

        showToastMessage({
          message:
            Object.keys(errorsAll).length > 0
              ? "Validation Error!"
              : "Something went wrong!",
          color: "danger",
        });
        setErrors(errorsAll);
      }

      if (error?.type === "GeneralError") {
        showToastMessage({
          message: error.message || "An unknown general error occurred.",
          color: "danger",
        });
      }
      setCreateFormUpdateLoading(false);
    }
  }
  function handleResetForm(data) {
    setEmployeeFamilyInput({ ...structuredClone(FAMILY_INITIAL_STATE), ...data })
  }
  function handleBlurFn(e, name) {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    const fieldSchema = createFamilySchema.extract(name);
    const { error } = fieldSchema.validate(value, {
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  }

  const handleChangeFunction = (e, name) => {
    let value = e;
    if (e && e.target) {
      value = e.target.value;
    }
    if (
      FAMILY_FORM_FIELDS[name]?.customOptions &&
      FAMILY_FORM_FIELDS[name]?.customOptions?.formatValueFn
    ) {
      value = FAMILY_FORM_FIELDS[name].customOptions.formatValueFn(
        value,
        employeeFamilyInput
      );
    }

    setEmployeeFamilyInput((prevInput) => ({
      ...prevInput,
      [name]: value,
    }));

    if (createFamilySchema) {
      const fieldSchema = createFamilySchema.extract(name);

      if (fieldSchema) {

        const { error } = fieldSchema.validate(value);

        if (!error) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
          }));
        }
      }
    }
  };


  const getInputFieldPropsFn = (fieldName = "") => {
    const { customOptions = {}, ...restProps } =
      FAMILY_FORM_FIELDS[fieldName] || {};
    const error = safeToString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: employeeFamilyInput,
        type: restProps.type || "text",
        error,
        handleBlurFn,
        handleChangeFunction,
      }),
    };

    return props;
  };

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [resource, setResource] = useState(null);

  useEffect(() => {
    // Refetch data whenever `page` or `search` changes
    setResource(fetchDataWithPromise(`${FAMILY_API.FAMILY_LIST.url}/${employeeID}`));

  }, [page, search]);
  const handleSubmit = async () => {
    setCreateFormUpdateLoading(true);

    const { error, value } = createFamilySchema.validate(
      pickProperties(employeeFamilyInput, Object.keys(structuredClone(FAMILY_INITIAL_STATE))),
      {
        abortEarly: false,
        context: {
          ...employeeFamilyInput,
        },

      }
    );

    let validationErrors = {};

    if (error && error?.details?.length > 0) {
      validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setCreateFormUpdateLoading(false);
    } else {
      setErrors({});
      const data = new FormData();
      Object.keys(value).map((key) => {
        data.append(key, value[key] ?? "");
      });

      if (selectedFile) {
        data.append("employee_family_file", selectedFile);
      }
      const isEdit = !!employeeFamilyInput?.family_id;

      try {
        const apiConfig = isEdit
          ? {
            data,
            ...FAMILY_API.FAMILY_UPDATE, 
            url: `${FAMILY_API.FAMILY_UPDATE.url}/${employeeID}/update/${employeeFamilyInput?.family_id}`,
          }
          : {
            data,
            ...FAMILY_API.FAMILY_CREATE,
            url: `${FAMILY_API.FAMILY_CREATE.url}/${employeeID}`,
          };
        const res = await fetchData(apiConfig);


        showToastMessage({ message: "Family Added successfully!" });
        setCreateFormUpdateLoading(false);
        setResource(fetchDataWithPromise(`${FAMILY_API.FAMILY_LIST.url}/${employeeID}`));
        handleClose()

      } catch (error) {
        if (error?.type === "JoiValidationError") {
          const errorsAll = {};

          error?.errors?.map((item) => {
            const { field, message } = item;
            errorsAll[field] = message;
          });

          showToastMessage({
            message:
              Object.keys(errorsAll).length > 0
                ? "Validation Error!"
                : "Something went wrong!",
            color: "danger",
          });
          setErrors(errorsAll);
        }

        if (error?.type === "GeneralError") {
          showToastMessage({
            message: error.message || "An unknown general error occurred.",
            color: "danger",
          });
        }
        setCreateFormUpdateLoading(false);
      }
    }
  };

  return {
    getInputFieldPropsFn,
    resource,
    handleSubmit,
    previewURL,
    setPreviewURL,
    setSelectedFile,
    setEmployeeFamilyInput,
    employeeFamilyInput,
    createFormUpdateLoading,
    handleClose,
    handleClickOpen,
    setOpen,
    handleResetForm,
    open,
    deleteDialogShow,
    setDeleteDialogShow,
    handleDeleteDialogOpen,
    handleDeleteFamilyFn,
    selectedFile
  };
}

export default useEmployeeFamilyService